import React from 'react';
import { Route } from 'react-router-dom';
import { useAuthentication } from 'common/contexts/Authentication';
import NotAuthenticatedError from '../errors/NotAuthenticatedError';

export default function GuardedRoute({ children, ...rest }) {
  const authentication = useAuthentication();

  if (!authentication.isAuthenticated()) {
    throw new NotAuthenticatedError();
  }

  return (
    <Route {...rest} render={() => {
      return children;
    }} />
  );
}
